import { Popover, Progress, Table, Tag, Tooltip } from "antd"
import { get } from "lodash"
import { Link } from "react-router-dom"
import React, { useEffect } from "react"
import questionIcon from "images/question.svg"
import imgMark from "images/mark_item.svg"

import "./index.less"
import { WORKING_ENVIRONMENT_LABEL } from "../../utils/constants"

const ResultTableByDivisionV2 = (props) => {
  const contentVariation = (
    <div className="content-variation">
      <p>
        La <span>variación</span> hace referencia a la diferencia porcentual
        entre el resultado del indicador en la medición anterior versus la
        medición actual.
      </p>
      <div>
        <div className="content-variation__triangle content-variation__triangle--positive" />
        Variación positiva (incremento)
      </div>
      <div>
        <div className="content-variation__triangle" />
        Variación negativa (disminución)
      </div>
    </div>
  )

  const columns = () => {
    let baseColumns = []
    baseColumns = [
      ...baseColumns,
      {
        title: "Divisiones",
        key: "division_name",
        number: 1,
        render: (text, record) => record.division_name,
      },
      {
        title: "División superior",
        key: "division_parent_name",
        number: 2,
        render: (text, record) => record.division_parent_name || "-",
      },
      {
        title: "Nivel",
        key: "division_level",
        number: 3,
        render: (text, record) => record.division_level,
      },
      {
        title: "Tasa de respuesta",
        key: "response_rate",
        number: 4,
        render: (text, record) =>
          record.anonymity_check.valid ? (
            <Progress
              strokeColor={record.response_rate.rate_color}
              percent={record.response_rate.rate}
            />
          ) : (
            "-"
          ),
      },
      {
        title: props.measureInfo.survey_type_name,
        dataIndex: "metric_total_label",
        render: (text, record) =>
          record.anonymity_check.valid ? (
            <Tag color={record.color}>{record.value_visible}</Tag>
          ) : (
            "-"
          ),
        sorter: (a, b) => a.value - b.value,
        number: 5,
      },
    ]

    if (props.isEngagement) {
      baseColumns = [
        ...baseColumns,
        {
          title: "Engagement",
          dataIndex: "engagement",
          render: (text, record) =>
            record.anonymity_check.valid && record.engagement ? (
              <Tag color={record.engagement.color}>
                {record.engagement.value_visible}
              </Tag>
            ) : (
              "-"
            ),
          width: "143px",
          number: 7,
          sorter: (a, b) => {
            if (a.engagement && b.engagement) {
              return a.engagement.value - b.engagement.value
            }
            return 0
          },
        },
      ]
    }

    if (props.measureInfo.calculate_comparative.show) {
      baseColumns = [
        ...baseColumns,
        {
          title: () => (
            <span>
              Medición anterior{" "}
              <Popover placement="bottomRight" content={contentVariation}>
                <img
                  src={questionIcon}
                  alt="question"
                  style={{ marginLeft: 4, cursor: "pointer" }}
                />
              </Popover>
            </span>
          ),
          dataIndex: "previous",
          render: (text, record) => {
            if (!record.anonymity_check.valid) {
              return "-"
            }
            if (record.prev_value === "") {
              return "-"
            }

            return (
              <span>
                <strong>{get(record, "prev_value", "")} </strong>

                {get(record, "variation", 0) !== 0 && (
                  <>
                    <span
                      className={`${
                        get(record, "variation", 0) > 0
                          ? "green-text"
                          : "red-text"
                      }`}>
                      {get(record, "variation_display", 0)}
                    </span>
                    <div
                      className={`triangle ${
                        get(record, "variation", 0) > 0
                          ? "triangle--positive"
                          : ""
                      }`}
                    />
                  </>
                )}
              </span>
            )
          },
          width: "120px",
          number: 6,
        },
      ]
    }

    if (props.showActions) {
      let segmentString = ""

      if (props.useSegments) {
        segmentString = `&id_segment=${props.selectedSegment}`
      }

      baseColumns = [
        ...baseColumns,
        {
          title: "Acciones",
          key: "actions",
          number: 8,
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <Link
                className="link_details_division"
                to={`/reports/measure/${
                  props.measureInfo.id_measure
                }/divisions/${
                  record.id
                }/dimensions${`?id_division=${record.id}${segmentString}`}&back=divisions`}>
                Ver análisis detallado &gt;
              </Link>
            ) : (
              <Popover
                content={
                  <div style={{ maxWidth: 220, textAlign: "center" }}>
                    El total de respuestas debe ser mayor o igual a{" "}
                    {record.anonymity_check.current_used} para poder mostrar los
                    resultados.
                  </div>
                }>
                <div style={{ width: "fit-content" }}>
                  Ver análisis detallado &gt;
                </div>
              </Popover>
            ),
        },
      ]
    }

    sorterBy(baseColumns, "number", "asc")
    return baseColumns
  }
  if (props.measureInfo.calculate_comparative) {
    return (
      <Table
        bordered
        size="small"
        columns={columns()}
        rowKey={(record) => record.id_division}
        dataSource={props.isEngagement ? props.dataWithEngagement : props.data}
      />
    )
  }

  return <></>
}

export default ResultTableByDivisionV2
